import {Slide} from "@mui/material";
import Modal from "@mui/material/Modal";
import {useEffect, useRef} from "react";
import {get_nested} from "../../services/JsonHandler";
import {doesFrontendExerciserExist} from "../../helpers/ExerciserHelper";
import DetailedCourseBottomBar from "../../components/bars/courses/DetailedCourseBottomBar";
import DetailedCourseScreenHeader from "../../components/others/courses/DetailedCourseScreenHeader";
import DetailedCourseScreenContent from "../../components/others/courses/DetailedCourseScreenContent";
import SystemModalClosingVoid from "../../components/others/SystemModalClosingVoid";

export default function DetailedCourseScreen({ open,
                                               handleClose,
                                               levelA,
                                               // ---- Flash
                                               isFlashLoading,
                                               fetchFlashQuestions,
                                               // ---- Exerciser
                                               fetchExerciserProblem,
                                               isExerciserLoading }) {
    // Used in CoursesLevelAItem to display side modal
    // with levelA details and action buttons

    // PROPERTIES
    const modalRef = useRef();
    const levelAIdentifier = get_nested(["identifier"], levelA, null)
    const hasBackendExerciser = get_nested(['hasExerciser'], levelA, false)
    const isExerciserPublished = get_nested(['publishExerciser'], levelA, false)
    const hasExerciser = doesFrontendExerciserExist(levelAIdentifier) && hasBackendExerciser && isExerciserPublished

    // HOOKS
    useEffect(() => {
        if (!open) {
            if (document.activeElement instanceof HTMLElement) {
                document.activeElement.blur();
            }
        }
    }, [open]);

    // BUILD
    return (
        <Modal open={open}
               onClose={handleClose}
               disableEnforceFocus>
            <Slide direction="left" in={open} mountOnEnter unmountOnExit>
                <div ref={modalRef}
                     className="overflow-auto w-full h-[100svh] flex outline-none">
                    <SystemModalClosingVoid handleClose={handleClose} />
                    <div className={"bg-backgroundLight3 w-[416px] min-w-[416px] h-full flex flex-col justify-between"}>
                        <DetailedCourseScreenHeader levelA={levelA}
                                                    handleClose={handleClose} />
                        <DetailedCourseScreenContent levelA={levelA} />
                        <DetailedCourseBottomBar fetchFlashQuestions={fetchFlashQuestions}
                                                 isFlashLoading={isFlashLoading}
                                                 fetchExerciserProblem={() => fetchExerciserProblem(levelAIdentifier)}
                                                 isExerciserLoading={isExerciserLoading}
                                                 hasExerciser={hasExerciser} />
                    </div>
                </div>
            </Slide>
        </Modal>
    );
}